import { render, staticRenderFns } from "./WordList.vue?vue&type=template&id=77561a5a&scoped=true&"
import script from "./WordList.vue?vue&type=script&lang=ts&"
export * from "./WordList.vue?vue&type=script&lang=ts&"
import style0 from "./WordList.vue?vue&type=style&index=0&id=77561a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77561a5a",
  null
  
)

export default component.exports